import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, Stack, Typography } from '@mui/material';
import { taskRequest } from '../components/Tasks/EnforcedTaskForm';
import { useSelector } from 'react-redux';
import ItemsViewer from '../components/Common/ItemsViewer';

/**
 * Общий список enforce; legacyView сохраняет исходный вход справочника.
 * Прямой /tasks по-прежнему использует собственные старые permissions.tasks.
 */
const TasksScreen = ({ legacyView }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    taskRequest('/api/directories/tasks')
      .then(setData)
      .catch((failure) => setError(failure.message));
  }, []);

  const slug = 'tasks';
  const rootUrl = 'api/directories';
  const section = '';
  const { userInfo, permissions } = useSelector((state) => state.auth);

  const perm = {
    canRead: userInfo?.isAdmin || !!permissions?.tasks?.read,
    canCreate: userInfo?.isAdmin || !!permissions?.tasks?.create,
    canUpdate: userInfo?.isAdmin || !!permissions?.tasks?.update,
    canDelete: userInfo?.isAdmin || !!permissions?.tasks?.delete,
  };
  if (error) {
    return <Alert severity='error'>{error}</Alert>;
  }

  if (!data) {
    return <p>Загрузка задач…</p>;
  }

  if (data.mode === 'enforce') {
    return (
      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography variant='h4'>Задачи</Typography>
          <Link to='/tasks/new'>Новая задача</Link>
          {data.rows.map((task) => (
            <Link key={task._id} to={`/tasks/${task._id}`}>
              {task.title} — {task.assignee?.name} {task.visible ? '' : '(скрыта)'}
            </Link>
          ))}
        </Stack>
      </Box>
    );
  }

  if (legacyView) {
    return legacyView;
  }

  return (
    <ItemsViewer
      rootUrl={rootUrl}
      section={section}
      slug={slug}
      permissions={perm}
    />
  );
};

export default TasksScreen;
